<template>
  <action-message :on="showToast" :message="toastMessage" />
  <div
    class="
      flex
      justify-between
      shadow
      border-gray-200
      bg-gray-50
      border
      overflow-hidden
      sm:rounded-lg
      px-4
      py-5
      sm:p-6
      mb-14
    "
  >
    <div class="flex">
      <CalendarIcon class="h-9 w-9 text-vice-teal-500 mr-4"></CalendarIcon>
      <div>
        <h3 class="text-lg font-medium">Proof of attendance</h3>
        <div class="mt-1">
          <div class="flex flex-row text-sm">
            <div class="mr-2 mt-1">{{ $page.props.presentMarker.presence_percentage }}%,</div>
            <div class="mr-2 mt-1">
              {{ $page.props.presentMarker.presence_time }}
            </div>

            <div>
              <ViceBadge small :class="getStatusBageClass()">{{ getPreseceStatus() }}</ViceBadge>
            </div>
          </div>
        </div>
      </div>
    </div>

    <slot name="actions">
      <div v-if="$page.props.presentMarker.marked_as_present">
        <a
          :href="$page.props.presentMarker.cert_download_link"
          target="_blank"
          class="
            bg-vice-teal-500
            hover:bg-vice-teal-600
            rounded-sm
            text-sm
            px-3
            py-2
            focus:outline-none
            float-right
            mt-2.5
            text-white
          "
        >
          Generate proof
        </a>
      </div>
      <div v-else>
        <button
          class="rounded-sm text-sm px-3 py-2 focus:outline-none float-right mt-2.5 text-white"
          :class="requestVerificationButtonClass"
          @click="requestVerificationClick($event)"
          :disabled="requestVerificationButtonIsDisabled"
        >
          Request verification
        </button>
      </div>
    </slot>
  </div>
</template>

<script>
import axios from 'axios';
import { CalendarIcon } from '@heroicons/vue/outline';
import ViceBadge from '@/Components/Badges/ViceBadge.vue';
import ActionMessage from '@/Jetstream/ActionMessage.vue';

export default {
  name: 'ProofOfAttendance',
  components: {
    CalendarIcon,
    ViceBadge,
    ActionMessage,
  },
  data() {
    return {
      session_id: this.$page.props.session.id,
      user_id: this.$page.props.user.id,
      presence_marker: this.$page.props.presentMarker.marked_as_present,
      attendance_validation_requested_at:
        this.$page.props.presentMarker.attendance_validation_requested_at,
      showToast: false,
      toastMessage: 'Your request has been sent successfully',
      requestVerificationButtonIsDisabled: false,
      requestVerificationButtonClass: null,
      enabledRequestVerificationButtonClass: 'bg-vice-teal-500 hover:bg-vice-teal-600',
      disabledRequestVerificationButtonClass: 'bg-gray-200 hover:bg-gray-200 cursor-auto',
    };
  },
  mounted() {
    if (this.attendance_validation_requested_at) {
      this.requestVerificationButtonIsDisabled = true;
      this.requestVerificationButtonClass = this.disabledRequestVerificationButtonClass;
    } else {
      this.requestVerificationButtonClass = this.enabledRequestVerificationButtonClass;
    }
  },
  methods: {
    getPreseceStatus() {
      return this.presence_marker ? 'Present' : 'Needs verification';
    },

    getStatusBageClass() {
      return this.presence_marker ? 'gb-blue text-blue' : 'bg-amber-600 text-white';
    },

    requestVerificationClick(event) {
      event.stopPropagation();

      this.showToast = true;

      this.requestVerificationButtonClass = this.disabledRequestVerificationButtonClass;

      const requestData = {
        session_id: this.session_id,
        user_id: this.user_id,
      };

      axios.post(route('session.user.attendance-verification'), requestData);
    },
  },
};
</script>
<style scoped>
.bg-amber-600 {
  background-color: #ea580c;
}

.gb-blue {
  background-color: #99f6e4;
}

.text-blue {
  color: #5a1bb5;
}
</style>
